export default "__VITE_ASSET__Clvx3_y7__"